// extracted by mini-css-extract-plugin
export default {"contentWrapper":"contentWrapper___HigcX"};